export default "__VITE_ASSET__DUoeP8ol__"